import { useContext, useEffect } from 'react';
import { Text, Spinner, Modals, ModalContext, FlexContainer } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetPlans } from 'Containers/Plans/hooks';
import { createURL } from 'Containers/Plans/utils';
import { FRONT_PLANS, plansToLongName, PLAN_SHORT_NAME_DICTIONARY } from 'Constants/plans';
import { setBodyOverflow } from 'Styles/utils/utils';
import { ResultType } from 'Types/common';
import UpsellingCard from '../../../UpsellingCard';
import * as Styled from './styles';

const MandatoryResult = ({ data: upsellingProps }: { data: ResultType }): JSX.Element => {
  const { hideModal } = useContext(ModalContext);
  const { t } = useTranslation(locizeNS.RESULT);
  const { data: plans, isLoading: loading } = useFetchGetPlans();

  useEffect(() => {
    setBodyOverflow();
  }, []);

  const plansFiltered = plans?.filter(
    item =>
      item.name !== FRONT_PLANS.FLEX &&
      item.name !== FRONT_PLANS.FULL_PLUS &&
      item.name !== FRONT_PLANS.PRO_PLUS
  );

  return (
    <Modals.Centered maxSize="M" hasClose onClose={hideModal}>
      <Styled.ModalContent direction="column" fullHeight fullWidth>
        {!plansFiltered || loading ? (
          <FlexContainer fullHeight fullWidth align="center" justify="center">
            <Spinner size="M" justify="center" align="center" />
          </FlexContainer>
        ) : (
          <Styled.Container gap="dimension_16">
            <Text type="paragraphs" color="dark" size="XL_XL_S" align="center" mt="fds_size_16">
              {t('Result.Upselling.title')}
            </Text>
            <Text type="paragraphs" color="dark" size="XS_L_M" align="center">
              {t('Result.Upselling.subtitle')}
            </Text>
            <Styled.CardContainer>
              {plansFiltered?.map(
                item =>
                  item.name !== PLAN_SHORT_NAME_DICTIONARY.BASIC && (
                    <UpsellingCard
                      key={item.id}
                      upsellingProps={item}
                      successUrl={createURL('/xml/result', {
                        filing: 'true',
                        plans: plansToLongName(item.name),
                      })}
                      cancelUrl={createURL('/xml/result')}
                      result={upsellingProps}
                    />
                  )
              )}
            </Styled.CardContainer>
          </Styled.Container>
        )}
      </Styled.ModalContent>
    </Modals.Centered>
  );
};

export default MandatoryResult;
